if (window.FILTERS) {
    const filters = Object.values(window.FILTERS);

    import('../libs/jquery-ui').then(module => {
        filters.map(param => {
            $(`#slider${param.index}`).slider({
                min: Number(param.min),
                max: Number(param.max),
                values: [Number(param.valMin), Number(param.valMax)],
                range: true,
                stop: function (event, ui) {
                    $(`input#minCost${param.index}`).val($(`#slider${param.index}`).slider('values', 0));
                    $(`input#maxCost${param.index}`).val($(`#slider${param.index}`).slider('values', 1));
                },
                slide: function (event, ui) {
                    $(`input#minCost${param.index}`).val($(`#slider${param.index}`).slider('values', 0));
                    $(`input#maxCost${param.index}`).val($(`#slider${param.index}`).slider('values', 1));
                },
            });

            const minCost = $(`input#minCost${param.index}`);
            const maxCost = $(`input#maxCost${param.index}`);

            [minCost, maxCost].forEach((jqueryObj) => {
                jqueryObj.click((e) => {
                    window.doNotReactToResizeWindowEvent = true;
                });

                jqueryObj.blur((e) => {
                    //window.doNotReactToResizeWindowEvent = false;  // закоментил т.к. не понятно когда его можно обнулять.
                })

            })

            $(`input#minCost${param.index}`).change(function () {
                var value1 = $(`input#minCost${param.index}`).val();
                var value2 = $(`input#maxCost${param.index}`).val();

                if (parseInt(value1) > parseInt(value2)) {
                    value1 = value2;
                    $(`input#minCost${param.index}`).val(value1);
                }

                $(`#slider${param.index}`).slider('values', 0, value1);
            });

            $(`input#maxCost${param.index}`).change(function () {
                var value1 = $(`input#minCost${param.index}`).val();
                var value2 = $(`input#maxCost${param.index}`).val();

                if (value2 > param.paramMax) {
                    value2 = param.paramMax;

                    $(`input#maxCost${param.index}`).val(param.paramMax);
                }

                if (parseInt(value1) > parseInt(value2)) {
                    value2 = value1;
                    $(`input#maxCost${param.index}`).val(value2);
                }

                $(`#slider${param.index}`).slider('values', 1, value2);
            });
        });
    });
}
